import clsx from "clsx";

const RoastLevel = ({ roastLevel, activeCollectionHandler, activeCollection }) => {
  const isActive = roastLevel === activeCollection.collectionHandle;

  return (
    <div className="relative flex flex-col items-center justify-center">
      <span
        className={clsx(
          "hidden md:block w-full text-center font-semibold px-4 py-0 rounded border border-white uppercase transition cursor-pointer hover:bg-white hover:text-[#4d4e53]",
          isActive ? "bg-white text-[#4d4e53]" : "text-white"
        )}
        onClick={activeCollectionHandler}
        roastlevel={roastLevel}>
        {roastLevel.replace("-", " ")}
      </span>

      <span
        className={clsx(
          "absolute top-1/2 left-1/2 custom-translate-x-y-50 flex flex-col justify-center items-center w-full text-center font-semibold px-4 py-2 uppercase transition cursor-pointer md:hidden h-full"
        )}
        onClick={activeCollectionHandler}
        roastlevel={roastLevel}>
        <span
          className={clsx(
            "inline-flex md:w-[20px] md:h-[20px] rounded-full border-2 border-white",
            isActive ? "w-[20px] h-[20px]" : "w-[12px] h-[12px]"
          )}
          roastlevel={roastLevel}
          onClick={activeCollectionHandler}></span>
      </span>
    </div>
  );
};

export default RoastLevel;
